import React from 'react';

import IconWithText from 'components/Widgets/IconWithText';

export default function PrepareReportReturnToWork() {
  return (
    <>
      <h6 className="text-center" style={{ maxWidth: '600px', margin: '0 auto', paddingTop: '80px' }}>
        LeggUP is dedicated to creating successful workplace
        readiness through positive habit and behavior changes. We focus on enhancing
        your confidence and readjustment skills—no rushing, no added pressure,
        just support for your successful transition.
      </h6>

      <div className="row" style={{ marginTop: '100px', paddingBottom: '100px' }}>
        <div className="col text-center">
          <IconWithText
            iconClassName="onboarding-balance-icon big-icon bg-secondary mx-auto"
          />

          <h3 className="mt-2 mb-2">67%</h3>
          <h6>reported increased confidence</h6>
        </div>

        <div className="col text-center">
          <IconWithText
            iconClassName="onboarding-stress-icon big-icon bg-secondary mx-auto"
          />

          <h3 className="mt-2 mb-2">42%</h3>
          <h6>reported reduced anxiousness</h6>
        </div>
      </div>
    </>
  );
}
